module.exports = {"introduction":{"alias":"Intro","subtabs":{"get-started":"Getting Started"}},"colors":{"alias":"Colors","subtabs":{"guidlines":"Color Guidelines","palette":"Color Palette","combinations":"Color Combinations","usage":"Color Usage","accessibility":"Accessibility"}},"components":"Core Components","structure":"Structure","navigation":"Navigation"}


//////////////////
// WEBPACK FOOTER
// ./docs/sitemap.json
// module id = lHmF
// module chunks = 13 14